import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addInvoiceSetting = (invoice_series,invoice_past_due_bucket,invoice_template,tax_calculation,default_receipt_method) => {
  return axios.post(API + "company/company-settings/", {
    invoice_series    ,
    invoice_past_due_bucket,
    invoice_template,
    tax_calculation,
    default_receipt_method


  },{headers: authHeader(),});
};
const AddInvoiceSettingService = {
    addInvoiceSetting,
    
  };
  export default AddInvoiceSettingService;